<template>
  <div class="warpper_page">
    <div class="warpper_page_top">
      <div class="warpper_top disFlex">
        <h2 class="warpper_top_title mr10">业绩</h2>
      </div>

      <ul class="list_rpt_type">
        <li class="item_rpt_type" :class="{ curRpt: curIdx === 3 }" @click="goPage(3, 'personRpt')">个人</li>
        <li class="item_rpt_type" :class="{ curRpt: curIdx === 2 }" @click="goPage(2, 'groupRpt')">小组</li>
        <li class="item_rpt_type" :class="{ curRpt: curIdx === 1 }" @click="goPage(1, 'achievementRpt')">门店</li>
      </ul>

      <dl class="search_title">
        <div class="search_top">
          <dd class="search_item mr20">
            <label class="item_search_lb">门店：</label>
            <div class="item_search_in">
              <a-select class="w120" placeholder="请选择门店" v-model="queryParam.storeId" @change="storeChange">
                <a-select-option :value="item.deptId" v-for="item in dept" :key="item.deptId">
                  {{ item.deptName }}
                </a-select-option>
              </a-select>
            </div>
          </dd>
          <dd class="search_item mr20">
            <label class="item_search_lb">日期：</label>
            <div class="item_search_in">
              <a-date-picker
                class="mr20"
                v-model="queryParam.startDate"
                :disabled-date="disabledStartDate"
                show-time
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                placeholder="开始时间"
                @openChange="handleStartOpenChange"
              />
              <a-date-picker
                class="mr20"
                v-model="queryParam.endDate"
                :disabled-date="disabledEndDate"
                show-time
                valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD"
                placeholder="结束时间"
                :open="endOpen"
                @openChange="handleEndOpenChange"
              />
            </div>
          </dd>

          <div style="display:flex;align-items:center">
            <a-button @click="getList" class="mr20">查询</a-button>
            <a-button
              type="default"
              class="btn_export"
              @click="exportHandle"
              v-hasPermi="['statistics:comprehensiveStatistics:export']"
            >
              <a-icon type="download" />导出
            </a-button>
          </div>
        </div>
        <div class="search_bottom">
          <div class="item_search">
            <a-radio-group default-value="week" @change="updateDateHandle" v-model="radioDate" button-style="solid">
              <a-radio-button value="week"> 本周 </a-radio-button>
              <a-radio-button value="month"> 本月 </a-radio-button>
              <a-radio-button value="quarter"> 本季 </a-radio-button>
              <a-radio-button value="year"> 本年 </a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </dl>
    </div>
    <div class="warpper_page_body" id="warpper_page_body" v-hasPermi="['statistics:comprehensiveStatistics:list']">
      <div class="results_wrapper" id="results_wrapper">
        <a-table
          v-if="earninglist"
          :loading="loading"
          bordered
          :columns="columns"
          :data-source="earninglist"
          :scroll="{ y: scrollHeight }"
          :rowKey="
            (item, index) => {
              return index
            }
          "
        >
          <template slot="header" slot-scope="text, item">
            <div v-if="item.team === '总计'" class="bg_circle bgColorf0553a">
              <a-icon type="fund" style="{color:'#fff',fontSize:'14px'}" />
            </div>
            <div v-else class="bg_circle">
              <div class="bg_circle">{{ item.team.substring(0, 2) }}</div>
            </div>
          </template>

          <template slot="team" slot-scope="text, item">
            <p class="name-box">{{ item.team }}</p>
          </template>
        </a-table>
        <no-data v-else></no-data>
      </div>
    </div>
  </div>
</template>

<script>
import { earningList } from '@/api/achievement/earningRpt'
import touristApi from '@/api/system/tourist/tourist.js'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'

const columns = [

      {
        title: '',
        dataIndex: 'team',
        key: 'team',
        align: 'center',
        scopedSlots: { customRender: 'team' },
        width: '100px'

  },
      {
        title: '房源新增',
        //  sorter: true,
        dataIndex: 'cnewHouse',
        key: '3',
        scopedSlots: { customRender: 'cnewHouse' }
      },
      {
        title: '房源跟进',
        //  sorter: true,
        dataIndex: 'cfollowHouse',
        key: '4',
        scopedSlots: { customRender: 'cfollowHouse' }
      },
      {
        title: '委托量',
        //  sorter: true,
        dataIndex: 'centrust',
        key: '5',
        scopedSlots: { customRender: 'centrust' }
      },
      {
        align: 'center',
        title: '钥匙',
        dataIndex: 'ckey',
        key: '6',

        scopedSlots: { customRender: 'ckey' }
      },
      {
        align: 'center',
        title: '房源被带看量',
        //  sorter: true,
        dataIndex: 'lookByHouse',
        key: '7',
        scopedSlots: { customRender: 'lookByHouse' }
  },

      {
        align: 'center',
        //  sorter: true,
        title: '客源新增',
        dataIndex: 'cnewCustomer',
        key: '8',
        scopedSlots: { customRender: 'cnewCustomer' }
      },
      {
        align: 'center',
        title: '带看量',
        //  sorter: true,
        dataIndex: 'lookByCustomer',
        key: '9',
        ellipsis: true,
        scopedSlots: { customRender: 'lookByCustomer' }
      },
      {
        title: '一带多看',
        align: 'center',
        dataIndex: 'multipleLook',
        key: '10',
        ellipsis: false,
        scopedSlots: { customRender: 'multipleLook' }
      }
]

export default {
  name: 'AchievementGroupRpt',
  components: {},
  mixins: [tableMixin],
  data () {
    return {
      scrollHeight: 1000,
      totalVo: null, // 合计数据
      earninglist: [], // 列表数据
      loading: false,
      curIdx: 2,
      endOpen: false,
      type: '',

      endDate: undefined, //	结束日期
      listType: 2, //	列表类型（1：门店 2：小组 3：个人）
      pageNum: 1, //	当前页数
      pageSize: 1000, //	分页大小
      startDate: undefined, //	开始日期
      dept: [], // 门店列表

      queryParam: {
        // 必填
        endDate: undefined, //	结束日期
        listType: 2, //	列表类型（1：门店 2：小组 3：个人）
        pageNum: 1, //	当前页数
        pageSize: 10, //	分页大小
        startDate: undefined, //	开始日期
        // 非必填
        isAsc: undefined, //	排序的方向
        // isDimission:undefined,//	是否显示离职人员业绩 字典表类型：sys_yes_no
        orderByColumn: undefined, //	排序列
        storeId: undefined, //	门店ID
        teamId: undefined, //	部门ID
        userId: undefined //	员工ID
      },
      dataInfo: {},

      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      },
      columns,
      radioDate: 'week'
    }
  },
  filters: {},
  created () {
    this.getStoreList()
    this.radioDate = 'week'
    this.updateDateHandle()
  },
  computed: {},
  watch: {},
  mounted () {
    window.addEventListener('scroll', this.menu)
  },
  methods: {
    menu () {
      const FIXOBJ = document.getElementById('warpper_page_body')
      const LIMITTOP = FIXOBJ.offsetTop
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      const CONH = document.body.clientHeight - 390
      if (this.scroll >= LIMITTOP) {
        this.scrollHeight = CONH || 600
      }
    },
    storeChange (e) {
      this.getList()
    },
    getList () {
      this.loading = true
      earningList(this.queryParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.totalVo = resData.comprehensiveStatisticsVo
          this.earninglist = resData.voPage.records
          if (this.earninglist && this.earninglist.length > 0) {
            this.totalVo.team = '总计'
            this.earninglist.unshift(this.totalVo)
          }
        }
        this.loading = false
      })
    },
    queryHandle () {
      this.queryParam = {
        // 必填
        endDate: this.formatDate(this.endDate), //	结束日期
        listType: this.curIdx, //	列表类型（1：门店 2：小组 3：个人）
        pageNum: this.pageNum, //	当前页数
        pageSize: this.pageSize, //	分页大小
        startDate: this.formatDate(this.startDate), //	开始日期
        // 非必填
        isAsc: undefined, //	排序的方向
        // isDimission:undefined,//	是否显示离职人员业绩 字典表类型：sys_yes_no
        orderByColumn: undefined, //	排序列
        storeId: undefined, //	门店ID
        teamId: undefined, //	部门ID
        userId: undefined //	员工ID
      }
      this.getList()
    },
    goPage (val, pageName) {
      this.curIdx = 2

      this.$router.push({ path: '/achievement/' + pageName })
    },
    initQuery () {
      const now = new Date() // 当前日期
      const startTime = now
      const endTime = now
      this.endDate = endTime //	结束日期
      this.startDate = startTime //	开始日期
      console.log('startDate', this.startDate)
      this.queryHandle()
    },
    updateDateHandle () {
      const timeType = this.radioDate
      this.type = timeType
      const now = new Date() // 当前日期
      let startTime, endTime
      var nowDayOfWeek = now.getDay() // 今天本周的第几天
      nowDayOfWeek = nowDayOfWeek - 1
      var nowDay = now.getDate() // 当前日
      const nowMonth = now.getMonth() // 当前月
      const nowYear = now.getFullYear() // 当前年
      const jd = Math.ceil((nowMonth + 1) / 3)
      switch (timeType) {
        case 'week':
          startTime = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek)
          endTime = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
          break
        case 'month':
          startTime = new Date(nowYear, nowMonth, 1)
          endTime = new Date(nowYear, nowMonth + 1, 0)
          break
        case 'quarter':
          startTime = new Date(nowYear, (jd - 1) * 3, 1)
          endTime = new Date(nowYear, jd * 3, 0)
          break
        case 'year':
          startTime = new Date(nowYear, 0, 1)
          endTime = new Date(nowYear, 11, 31)
          break
      }
      this.startDate = startTime //	开始日期
      this.endDate = endTime //	结束日期

      this.queryHandle()
    },
    formatDate (date) {
      let d = date.getDate() // 当前日
      d = d < 10 ? '0' + d : d
      let m = date.getMonth() // 当前月
      m = m + 1
      m = m < 10 ? '0' + m : m
      const y = date.getFullYear() // 当前年
      return y + '-' + m + '-' + d
    },
    disabledStartDate (startValue) {
      const endValue = this.queryParam.endDate
      if (!startValue || !endValue) {
        return false
      }
      return startValue.valueOf() >= new Date(endValue).valueOf()
    },
    disabledEndDate (endValue) {
      const startValue = this.queryParam.startDate
      if (!endValue || !startValue) {
        return false
      }
      return endValue.valueOf() <= new Date(startValue).valueOf()
    },
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
      this.getList()
    },
    handleEndOpenChange (open) {
      this.endOpen = open
      this.getList()
    },
    // 获取门店列表
    getStoreList () {
      const storeParam = {
        deptLev: '1' // 部门等级 1门店 2小组
      }
      touristApi.getDeptList(storeParam).then((res) => {
        if (res.code === 200) {
          this.dept = res.data.map((item) => {
            return {
              deptId: item.deptId,
              deptName: item.deptName
            }
          })
        }
      })
    },
    /** 导出按钮操作 */
    exportHandle () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download(
            'comprehensiveStatistics/export',
            {
              ...that.queryParam
            },
            `g_${new Date().getTime()}.xlsx`
          )
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.search_top{
  display: flex;
  flex-wrap: wrap;}
  .search_item{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
.search_bottom{
  display: flex;
  margin-top: 15px;
  justify-content: flex-start;
}
/deep/ .ant-table-thead > tr > th{
  padding: 6px 6px
}
/deep/ .ant-table-tbody > tr > td{
  padding: 6px 6px
}
@import './report.less';
</style>
